import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CheckinSearchResultEffect } from './checkin-search-result.effect';
import { checkinSearchResultReducer } from './checkin-search-result.reducer';
import { CHECKIN_SEARCH_RESULT_STORE_NAME, CheckinSearchResultState } from './checkin-search-result.state';

/** Token of the CheckinSearchResult reducer */
export const CHECKIN_SEARCH_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<CheckinSearchResultState, Action>>(
  'Feature CheckinSearchResult Reducer'
);

/** Provide default reducer for CheckinSearchResult store */
export function getDefaultCheckinSearchResultReducer() {
  return checkinSearchResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CHECKIN_SEARCH_RESULT_STORE_NAME, CHECKIN_SEARCH_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([CheckinSearchResultEffect]),
  ],
  providers: [{ provide: CHECKIN_SEARCH_RESULT_REDUCER_TOKEN, useFactory: getDefaultCheckinSearchResultReducer }],
})
export class CheckinSearchResultStoreModule {
  public static forRoot<T extends CheckinSearchResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinSearchResultStoreModule> {
    return {
      ngModule: CheckinSearchResultStoreModule,
      providers: [{ provide: CHECKIN_SEARCH_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
